<div class="dialog-container">
  <h1 class="dialog-title">{{ 'PRESENTER.ITEM_TABLE_TOOLS.FILTER_ITEMS.TITLE' | translate }}</h1>

  @if (vm$ | async; as vm) {
    @if (!vm.loaded && vm.items.length === 0) {
      <div class="loading">
        <mat-progress-spinner mode="indeterminate" diameter="32"></mat-progress-spinner>
      </div>
    } @else {
      <div class="hint">{{ 'PRESENTER.ITEM_TABLE_TOOLS.FILTER_ITEMS.HINT' | translate }}</div>

      <div class="items-table" #itemsTableContainer>
        <gb-table
          [inDialog]="true"
          [enableSelect]="true"
          [tableData$]="tableData$"
          [displayedColumns$]="getDisplayedColumns$(itemType)"
          [loaded$]="loaded$"
          [totalItemCount]="vm.count"
          [selectedItems]="selectedItems"
          (checkboxChangeEvent)="onSelectedItemsChange($event)"
        ></gb-table>
        @if (isLoadingMore && !vm.loaded) {
          <div class="loading-more">
            <mat-progress-spinner mode="indeterminate" diameter="24"></mat-progress-spinner>
          </div>
        }
      </div>

      <div class="actions">
        <button mat-stroked-button type="button" (click)="cancel()">
          {{ 'CANCEL' | translate }}
        </button>
        <button mat-flat-button type="button" (click)="apply()">
          {{ 'APPLY' | translate }}
        </button>
      </div>
    }
  }
</div>

<ng-template #itemType let-data>
  <gb-item-type-chip [item]="data.item"></gb-item-type-chip>
</ng-template>
